const authConfig = {
    apiKey: "AIzaSyC4JWyA8jo-lkNdGGAmYqvnmtCp3yTHPYs",
    authDomain: "test-bd00d.firebaseapp.com",
    databaseURL: "https://test-bd00d.firebaseio.com",
    projectId: "test-bd00d",
    storageBucket: "test-bd00d.appspot.com",
    messagingSenderId: "969444673319"
};
export default authConfig